import { GsFormSchema } from '../../../components';
import { DEFAULT_CONFIG } from '../../../services/config/default.config';
import { HORIZONTAL_ALIGNMENT_SCHEMA } from './alignment.schema';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { buttonSchemaFields } from './../basics/button-fields.schema';
import { SPACING_SCHEMA } from './spacing.schema';

export const DEBITCARDDETAIL_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...BASIC_SCHEMA_FIELDS,
    ...HORIZONTAL_ALIGNMENT_SCHEMA,
    ...SPACING_SCHEMA,
    {
      formControlName: 'showNumberPage',
      label: 'components.debitCardDetail.schema.showNumberPage',
      type: 'checkbox',
      default: false
    },
    {
      formControlName: 'debitCardRegEx',
      label: 'components.debitCardDetail.schema.debitCardRegEx',
      type: 'text',
      default: '',
      if: {
        args: [
          {
            formControlName: 'showNumberPage',
            value: true
          }
        ]
      }
    },
    {
      formControlName: 'debitCardRegExErrorMessage',
      label: 'components.debitCardDetail.schema.debitCardRegExErrorMessage',
      type: 'text',
      default: '',
      if: {
        args: [
          {
            formControlName: 'showNumberPage',
            value: true
          }
        ]
      }
    },
    {
      formControlName: 'showProfilePage',
      label: 'components.debitCardDetail.schema.showProfilePage',
      type: 'checkbox',
      default: false
    },
    {
      formControlName: 'debitCardHideAlreadyHaveADebitCard',
      label: 'components.debitCardDetail.schema.debitCardHideAlreadyHaveADebitCard',
      type: 'checkbox',
      default: false
    },
    {
      formControlName: 'hideBonus',
      label: 'components.debitCardDetail.schema.hideBonus',
      type: 'checkbox',
      default: false
    },
    {
      formControlName: 'buttons',
      label: 'components.debitCardDetail.schema.buttons',
      type: 'group',
      expandable: true,
      default: DEFAULT_CONFIG.uiElements?.buttons ?? {},
      fields: buttonSchemaFields()
    }
  ]
};
